	import React from 'react';
	import './styles.css'

	const About = () => {
		return (
			<>
			<div className="abc" style={{marginTop: "100px", marginBottom: "160px"}}>
				<blockquote>
  					Ramesh Brothers Group, well known for it's wholes seller, is having a presence in started from a small tea business since 1979. Today many companies ownand operats, under it's umbrella. 
					We are serving over 500+ products with the turnover of 7 Cr having 300+ clients and 80+ villages. The group is leading stride in many exports and retail consumers all over kapadwanj taluka. Ramesh Brothers firm deals with 25+ companies. 
					Over the years , a long-lasting relationships of love and trust has developed between ramesh Brothers and its loyal consumers. The Group includes 13 employees. Our speciality is that we serves only India's most valuable brands.
					Besides of Ramesh Brothers we have another firm Mayur Traders. The Group Directors personally evaluates the product's quality and personally handles the marketing.
  					<span>About Us</span>
				</blockquote>
			</div>
			{/* <div>
				<h2>Our Values</h2>
				<p>The name 'Ramesh Brothers' symbolizes the co-existence of one and all creating long lasting relationships in society by dissolving differnces over a good cup of tea.
				We serve the best quality of products like tea, namkeen, spices, etc. consistently throughout the year to one and all. In other words, Ramesh Brothers firm stands for relationships and harmony.</p>
			</div>
			<div>
				<h2>Mission</h2>
				<p>Dealing with Indian companies and adding sweetness to relationships by serving the best quality products in every corner we can through retail and quick service.</p>
			</div>
			<div>
				<h2>Vision</h2>
				<p>Serving India based reputed brands and delivering superior value to all its stakeholders.</p>
				<p>logo</p>
			</div> */}
			</>
		)
	}

	export default About
